import { BlogSection } from '@/types/blog';

export const wartenRegelSection: BlogSection = {
  id: 'warten-regel',
  title: 'Die 48-Stunden-Regel für Käufe nutzen',
  content: `
    <h3>2. Die 48-Stunden-Regel für Käufe nutzen</h3>
    
    <p>
      Impulskäufe lassen sich reduzieren, indem du eine bewusste Pause einlegst. Die Neurowissenschaft zeigt: 
      Je mehr Zeit zwischen Impuls und Entscheidung liegt, desto stärker ist die Aktivierung des präfrontalen 
      Cortex – dem Teil des Gehirns, der für rationales Denken zuständig ist (McClure et al., 2004).
    </p>
    
    <div class="my-6 bg-joerg-50 p-5 rounded-lg border border-joerg-100">
      <h4 class="text-joerg-800 font-medium mb-3">So funktioniert die 48-Stunden-Regel:</h4>
      <ol class="list-decimal pl-5">
        <li class="mb-2">Bei jedem nicht-essentiellen Kauf über 50€: Warte mindestens 48 Stunden</li>
        <li class="mb-2">Trage den Wunsch in eine digitale oder analoge Wunschliste ein</li>
        <li class="mb-2">Nach 48 Stunden: Frage dich, ob du das wirklich brauchst und ob es deinen langfristigen Zielen dient</li>
        <li>Entscheide dann bewusst - oft wird die Kauflust bereits verflogen sein</li>
      </ol>
    </div>
  `
};